<script>
import FilePreviewElement from './FilePreviewElement.vue'
import { fileDataManage } from '@/observable'
import RCheckbox from './RCheckbox.vue'

export default {
	name: 'FileElement',
	components: { RCheckbox },
	props: {
		fileList: {
			type: Array,
			required: true
		}
	},
	computed: {
		fileDataManage() {
			return fileDataManage
		}
	},
	data() {
		return {
			checked: false,
		}
	},
	methods: {
		previewFile(item){
			this.$createFilePreview(FilePreviewElement, {item})
		},
		isChecked(v) {
			return this.fileDataManage.checkedList.some(x => x.id === v)
		},
		changeSelect(check, item) {
			if (check) {
				this.fileDataManage.checkedList.push(item)
			} else {
				this.fileDataManage.checkedList = this.fileDataManage.checkedList.filter(x => x.id !== item.id)
			}
      console.log(this.fileDataManage, 'sss')
		}
	}
}
</script>

<template>
	<div class="fileElement">
		<div class="item" v-for="item in fileList" :key="item.id">
			<el-tooltip placement="bottom">
				<div slot="content">{{ item.name }}</div>
				<div>
					<div class="imgBox" v-if="item.path && item.path.mime.startsWith('image')">
						<RCheckbox
							class="checkBtn"
							:checkStatus="isChecked(item.id)"
							@statusChange="e => changeSelect(e, item)"
						/>
						<div class="imageCtx">
							<img @click.stop="previewFile(item)" :src="item.path.url" alt="img" />
						</div>
					</div>
					<div class="videoBox" v-if="item.path && item.path.mime.startsWith('video')">
						<RCheckbox
							class="checkBtn"
							:checkStatus="isChecked(item.id)"
							@statusChange="e => changeSelect(e, item)"
						/>
						<img @click.stop="previewFile(item)" :src="require('@/assets/image/videoImg.png')" alt="video" />
					</div>
					<div class="audioBox" v-if="item.path && item.path.mime.startsWith('audio')">
						<RCheckbox
							class="checkBtn"
							:checkStatus="isChecked(item.id)"
							@statusChange="e => changeSelect(e, item)"
						/>
						<img @click.stop="previewFile(item)" :src="require('@/assets/image/audioImg.png')" alt="audio" />
					</div>
					<div class="name">{{ item.name }}</div>
				</div>
			</el-tooltip>
		</div>
	</div>
</template>

<style scoped lang="scss">
.fileElement {
	display: flex;
	flex-wrap: wrap;

	.item {
		display: flex;
		flex-direction: column;
		margin: 20px;
		img{
      max-width: 100%;
      max-height: 100%;
      z-index: 2;
		}
		.imgBox {
			cursor: pointer;
			position: relative;
			.imageCtx{
				height: 130px;
				overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
			}
		}

		.videoBox {
			cursor: pointer;
			position: relative;
		}

		.audioBox {
			cursor: pointer;
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 20px;
			img{
				width: 90%;
				height: 90%;
			}
		}
		.audioBox::before{
			content: '';
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			background-color: #efefef;
			z-index: 1;
			border-radius: 8px;
		}

		.checkBtn {
			position: absolute;
			z-index: 5;
			top: -10px;
			right: -10px;
			width: 20px;
			height: 20px;
			cursor: pointer;
		}

		.name {
			font-size: 20px;
			width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
      text-align: center;
		}
	}
}
.fileElement_audio{
	.item{
		width: 110px;
		.audioBox{
			width: 70px;
			height: 70px;
		}
	}
}
.fileElement_image{
	.item{
		width: 140px;
	}
}
.fileElement_video{
	.item{
		width: 140px;
	}
}
</style>
